// extracted by mini-css-extract-plugin
export default {"addCustomerModal":"AddCustomerForm_addCustomerModal__bsHkS"};